module.exports = __webpack_public_path__ + "static/media/pie.de20b7d0.svg";